<template>
	<div class="r-b-toolsbar-wrap">
		<!-- <a
      href="https://wj.qq.com/s2/4368214/0e1d/"
      target="_blank"
      title="5周年庆典"
      class="questionnaire"
    >
      <span class="questionnaire__img"></span>
    </a> -->
		
		<!-- <button class="to-top" style="display: none;">
			<i></i>
		</button> -->
		<div target="_blank" title="双11钜惠" class="feedback1" @click="gotoActivity()">
			<span class="right__mascot"></span>
			<!-- <span class="feedback__text"></span> -->
		</div>
		
	</div>
</template>

<script>
import WechatCode from "@/components/WechatCode.vue";
export default {
	components: {
		WechatCode,
	},
	methods: {
		gotoActivity() {
			this.$router.push({ path: "/activity" });
		}
	}
};
</script>

<style scoped lang="scss">
.customer-service {
	position: relative;

	&:hover {
		.wechat-code {
			visibility: visible;
		}
	}
}

.wechat-code {
	position: absolute;
	right: 42px;
	top: -52px;
	visibility: hidden;
}
</style>
